define(function (require) {
	const ViewManager = require('civicsUtils/view_manager');
	const AvailableFeatures = require('civicsUtils/available_features');
	const Utils = require('civicsUtils/general_utilities');
	const tpl = require('civicsViews/favoriteContacts/templates/t_itv_select_favorite.hbs');

	return Marionette.ItemView.extend({
		template: tpl,
		tagName: 'div',
		className: 'favorite-items list-row',
		attributes: {
			'role': 'row'
		},
		modelEvents: {
			change: 'render',
		},
		events: {
			'change .select-contact': 'onToggleSelected'
		},
		ui: {
			checkboxFav:'input[name=selectContact]',
		},
		initialize: function (options) {
			this.config = options.config;
			this.collection = options.collection;
			this.selectedFavorites = options.selectedFavorites;
			this.isInviteProcess = options.isInviteProcess;
		},
		onShow: function () {

		},
		onRender: function () {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

			if(this.addDisableClass()){
				this.$el.addClass('disabled');
			}
		},
		addDisableClass: function () {
			return this.model.get('isExpired') === true || this.isInviteProcess && this.model.get('hasEmail') === false;
		},
		onToggleSelected: function (e) {
			const isChecked = this.ui.checkboxFav.is(':checked');
		
			if (isChecked) {
				this.selectedFavorites.add(this.model);
			} else {
				this.selectedFavorites.remove(this.model);
			}
			this.model.set('isSelected', e.target.checked);
		},
		templateHelpers:function(){
			return {
				config: this.config,
				isExpired: this.model.get('isExpired'),
				noEmail: this.isInviteProcess && this.model.get('hasEmail') == false
			}
		},
	});
});
